module.exports = __webpack_public_path__ + "static/img/conure-small-case.5510e81.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/amenities/facilities/conure-small-case.jpg
// module id = 592
// module chunks = 0